export default __webpack_public_path__ + "static/arranger-b0e3553dabbd767e5eb1afb9e1282128.svg";